import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 导入element-ui组件库
import ElementUI from 'element-ui'
// 导入element-ui样式
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
// 全局使用element-ui
Vue.use(ElementUI)

// 应用启动时检查本地存储的认证状态
function initializeAuth() {
  const token = localStorage.getItem('topeak_token')
  const userStr = localStorage.getItem('topeak_user')

  if (token && userStr) {
    try {
      const user = JSON.parse(userStr)
      if (user.username) {
        store.commit('setAuth', { token, user })
      } else {
        // 数据格式不正确，清除
        localStorage.removeItem('topeak_token')
        localStorage.removeItem('topeak_user')
      }
    } catch (error) {
      // 解析失败，清除无效数据
      localStorage.removeItem('topeak_token')
      localStorage.removeItem('topeak_user')
    }
  }
}

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 初始化认证状态
    initializeAuth()
  }
}).$mount('#app')
